module.exports = __webpack_public_path__ + "img/subtract@2x.d3693602.png";